import Flex from 'typescript-styled-flex'
import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const HeaderInside = styled(Flex as any)<IWithSize>`
  @media (min-width: 321px) {
    padding: 0 ${({ size }) => (size ? 0.5 * size : 0.5)}em;
  }
  justify-content: space-between;
`

export default HeaderInside
